module.exports = __webpack_public_path__ + "img/icon_ig.d7198646.png";